import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useQueryClient } from 'react-query';
import { Resources } from '@/src/shared/constants/resources';
import { useSnackbar } from 'notistack';
import { getFunctions, httpsCallable } from 'firebase/functions';
import ClubCreateForm from '@/src/pages/clubProfile/create/createSteps/ClubCreateForm';
import { Box } from '@mui/material';

type ClubCreateAdminProps = {
  onClose: () => void;
};

export const ClubCreateAdmin = (props: ClubCreateAdminProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const form = useForm({ mode: 'all' });
  const queryClient = useQueryClient();
  const { onClose } = props;
  const [isLoading, setIsLoading] = React.useState(false);

  async function onSubmit(data) {
    const club = data.club;

    if (!club) {
      enqueueSnackbar('Club details are required', { variant: 'error' });
      return;
    }

    setIsLoading(true);
    try {
      const instance = httpsCallable(getFunctions(), 'clubs-club-create');
      await instance(club);

      enqueueSnackbar('Club details saved successfully', { variant: 'success' });
      queryClient.invalidateQueries(Resources.Clubs);
      onClose();
    } catch (e) {
      const errorMessage = e?.message || 'Failed to save club details';
      const isAlreadyExistsError = errorMessage.includes('already exists');

      if (isAlreadyExistsError) {
        queryClient.invalidateQueries(Resources.Clubs);
        onClose();
      } else {
        enqueueSnackbar(errorMessage, { variant: 'error' });
      }
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Box>
      <FormProvider {...form}>
        <form
          style={{
            minHeight: '514px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <ClubCreateForm isLoading={isLoading} onlyClubCreate={true} />
        </form>
      </FormProvider>
    </Box>
  );
};

